/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Syles
import { ContainerForm, ContentForm, TitleForm } from "components/styles";
import { Footer } from "./styles";
//#endregion
//#region Components
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import CustomButton from "components/CustomButton/CustomButton";
import BackToView from "components/BackToView/BackToView";
import AcadReinforceDetail from "../components/AcadReinforceDetail/AcadReinforceDetail";
import CheckAcadReinforceExistence from "../components/CheckAcadReinforceExistence/CheckAcadReinforceExistence";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Utils
import useResumeData from "views/RefuerzoAcademico/utils/hooks/useResumeData";
import useDataRelatedToForm from "views/RefuerzoAcademico/utils/hooks/useDataRelatedToForm";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
//#endregion

const View = ({ loadingRequest }) => {
	//#region States
	const [
		loadedDataRelatedToAcadReinforceForm,
		setLoadedDataRelatedToAcadReinforceForm,
	] = useState(false);
	//#endregion
	const navigate = useNavigate();
	const { fetchData, dataRelatedToForm } = useDataRelatedToForm({
		loadingRequest,
		setLoadedDataRelatedToAcadReinforceForm,
	});
	const acadReinforceResumeData = useResumeData({
		loadingRequest,
		dataRelatedToForm,
		loadedDataRelatedToAcadReinforceForm,
	});
	//#region Effects
	useEffect(() => {
		fetchData();
	}, []);
	//#endregion
	return (
		<ContainerForm>
			<HelmetUTP title="Detalle del refuerzo" />
			<BackToView
				text="Volver a refuerzos"
				to={ABSOLUTE_PATHS.ACAD_REINFORCE_LIST}
			/>
			{acadReinforceResumeData.value && (
				<TitleForm>Detalle del refuerzo</TitleForm>
			)}
			<ContentForm>
				<AcadReinforceDetail
					dataRelatedToForm={dataRelatedToForm}
					acadReinforceResumeData={acadReinforceResumeData.value}
					loadedDataAboutAcadReinforceForm={
						loadedDataRelatedToAcadReinforceForm
					}
					isDetailAcadReinforce
				/>
			</ContentForm>
			{acadReinforceResumeData.value && (
				<Footer>
					<CustomButton
						text="Cerrar"
						onClick={() =>
							navigate(ABSOLUTE_PATHS.ACAD_REINFORCE_LIST)
						}
					/>
				</Footer>
			)}
		</ContainerForm>
	);
};

const AcadReinforceDetailView = () => {
	const loadingRequest = useLoadingRequest();
	return (
		<>
			<Preloader {...loadingRequest.value} />
			<CheckAcadReinforceExistence
				loadingRequest={loadingRequest}
				defaultPath={ABSOLUTE_PATHS.ACAD_REINFORCE_LIST}
			>
				<View loadingRequest={loadingRequest} />
			</CheckAcadReinforceExistence>
		</>
	);
};

export default AcadReinforceDetailView;
